module.exports = __webpack_public_path__ + "static/media/our_vision.7678fe71.png";